<template>
  <ValidationProvider name="new media item" slim vid="media_id_to">
    <template #default="{ errors }">
      <BaseFormGroup>
        <div>
          <img
            v-if="value"
            :src="value.url"
            :alt="value.name"
            class="rounded-lg mb-2 cursor-pointer"
            @click="openMediaSelectDialog"
          />
          <BaseFormInput type="hidden" :value="coverId" />
          <BaseButton
            v-if="!value"
            primary
            outline
            small
            type="button"
            :disabled="disabled"
            @click="openMediaSelectDialog"
          >
            Select Media
          </BaseButton>
        </div>
        <BaseFormInlineMessage v-if="errors.length" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </BaseFormGroup>
    </template>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: null,
    },
    disabled: Boolean,
  },
  computed: {
    coverId() {
      return this.value?.id || null;
    },
  },
  methods: {
    onSelect(media) {
      this.$emit('input', media);
    },
    openMediaSelectDialog() {
      if (this.disabled) {
        return;
      }

      this.$modal.show({
        component: () => import('Components/MediaLibrary/MediaSelectDialog.vue'),
        props: {
          mimeTypes: 'image/',
        },
        on: {
          select: this.onSelect,
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
